import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from '@/types/store'
import { user } from './modules/user/index'
import { getters } from './getters'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  modules: {
    user
  },
  getters
}
export default new Vuex.Store<RootState>(store)
